import { toast } from 'react-toastify';

import { ID, Response } from 'app/components/Table/core/types';

import { trimObject } from 'app/helpers';

import { API_URL } from 'app/constants/environments';

import { Organizations, OrganizationsQueryResponse } from './type';
import axios, { AxiosResponse } from 'axios';
import { OrganizationInfo } from 'theme/layout/components/aside/store';

const ORGANIZATION_URL = `${API_URL}/api/organizations`;

export const getOrganizations = (query: string): Promise<OrganizationsQueryResponse> => {
  return axios.get(`${ORGANIZATION_URL}?${query}`).then(
    (
      d: AxiosResponse<{
        data: {
          items: Array<Organizations>;
          total: number;
        };
      }>,
    ) => {
      return {
        data: d.data.data,
      };
    },
  );
};

export const deleteOrg = async (idItem: ID): Promise<void> => {
  try {
    await axios.delete(`${ORGANIZATION_URL}/${idItem}`);
  } catch (error) {
    console.log(`Error deleting item ${idItem}`);
    throw error;
  }
};

export const restoreOrg = async (idItem: ID): Promise<boolean> => {
  try {
    const response = await axios.post(`${ORGANIZATION_URL}/${idItem}/restore`);

    if (response.data.success) {
      toast.success('Restore organization successfully');
      return true;
    }

    return false;
  } catch (error: any) {
    console.log(`Error restoring item ${idItem}`);
    const errorMessage = error?.response?.data?.data?.errors || 'Error restoring organization';
    toast.error(errorMessage);
    throw error;
  }
};
export const updateOrg = (orgId: ID, name: string): Promise<OrganizationInfo | undefined> => {
  return axios
    .patch(`${ORGANIZATION_URL}/${orgId}`, trimObject({ name, id: orgId }))
    .then((response: AxiosResponse<Response<OrganizationInfo>>) => response.data)
    .then((response: Response<OrganizationInfo>) => response.data);
};

export const createOrg = ({ name }: { name: string }): Promise<OrganizationInfo | undefined> => {
  return axios
    .post(ORGANIZATION_URL, trimObject({ name }))
    .then((response: AxiosResponse<Response<OrganizationInfo>>) => response.data)
    .then((response: Response<OrganizationInfo>) => response.data);
};
